import { TrackedGame } from '../features/live-events/types/TrackedGame'

//NOTE: Remove hd game check when we want to release LET Price Points for mobile
export const showPricePointsFilter = (games: TrackedGame[]) => {
  const pcOrConsoleGameSelected = games.some((game) => game.game.isAvailableOnPCOrConsole())
  return pcOrConsoleGameSelected
}
